module.exports = __webpack_public_path__ + "img/pms_2.73b11b1a.png";